module.exports = __webpack_public_path__ + "img/icon-care-provider.7b18db17.svg";